export default "__VITE_ASSET__48ae421b__"